import React, { useEffect } from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';
import ContainerLine from '../../components/UIComponents/ContainerLine';
import { Title } from '../Expositor/styles';
import ParagraphDangerous from '../../components/UIComponents/ParagraphDangerous';
import CientificLibrary from '../CientificLibrary';
import CientificLibraryComponent from '../../components/CientificLibrary';
import { ContainerCientific } from '../CientificLibrary/styles';
import api from 'src/services/api';


const CDA: React.FC = () => {

  useEffect(() => {

    api.get('/cda');
  }, [])
  return (
    <>

      <ContainerLine className='full-width column column pad '>


        <Title style={{ color: '#555', fontSize: '16px', lineHeight: '20px' }} className="text-left width-full">Página não encontrada</Title>

      </ContainerLine>
    </>
  );
};
export default CDA;
